<template>
  <div
    class="curation-search-result"
    v-if="ss?.state?.result"
    :id="ss.state.storeId"
  >
    <div
      v-if="ss.state.searching"
      class="curation-search-result-loader"
    />

    <div
      class="curation-search-result-inner layout-col"
    >
      <SearchNohit
        v-if="ss.state.result.hit == 0"
      />

      <template v-else>
        <nav
          class="item-search-result-nav"
        >
          <p class="hit-num is-size-7-touch">
            {{ lsst('{}件見つかりました。', '{} hit', num(ss.state.result.hit)) }}
          </p>
          <div
            class="jps-search-select-options"
          >
            <SearchPagenav :ss="ss" />
            <SearchPagesize :ss="ss" class="jps-search-pagesize" />
          </div>
        </nav>

        <div
          class="curation-search-result-body layout-col"
          role="main"
          :aria-label="ls(dapLangGlobal.searchResults)"
          aria-live="assertive"
        >
          <BaseLayoutGrid
            v-if="ss.state.result.list.length > 0"
          >
            <div
              v-for="cur in ss.state.result.list"
              class="grid-item"
              :key="cur.id"
            >
              <UiDataCard type="curation" :data="cur" class="grid-item-card" />
            </div>
          </BaseLayoutGrid>

          <SearchPagination :ss="ss" autoscroll />
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
const { ls, lsst, num } = useI18n()

interface Props {
  ss: SearchStore<Curation>
}
withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.curation-search-result {
  position: relative;

  //:deep(.jps-card-icon) {
  //  position: absolute !important;
  //}
  :deep(.curation-search-result-inner) {
    gap: 0.5rem;
  }

  nav.item-search-result-nav {
    display: flex;
    align-items: center;
    gap: 0.25rem;

    @include is-mobile {
      flex-direction: column;
    }

    @include is-tablet {
      padding: 0 1rem;
    }

    > * {
      @include is-mobile {
        justify-content: center;
      }
    }

    .hit-num {
      flex-grow: 1;
    }

    .jps-search-select-options {
      display: flex;
      align-items: center;

      @include is-mobile() {
        justify-content: center;
      }

      .jps-search-pagesize {
        margin-left: 1rem;
      }
    }

    .jps-display-mode {
      display: flex;

      @include is-mobile {
        justify-content: center;
      }

      .jps-icon-button {
        margin-left: 0.25rem;
        color: $jps-gray-800;
        position: relative;
        @include transition-colors;
        @include ease();

        &:hover {
          color: oklch(54.6% 0.245 262.881);
        }

        &.jps-active {
          color: $jps-key-blue;
        }
      }
    }
  }

  .grid-item {
    width: 100%;
  }

  .grid-item-card {
    height: 100%;
  }

  .curation-search-result-body {
    gap: 1.5rem;
  }

  .curation-search-result-loader {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(256, 256, 256, 0.25);
    z-index: 999;
  }
}
</style>
